import React from "react"

import { AppIconChipToggle } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportProvidersExclusionSwitch() {
	const {
		filterProvidersExclusion,
		setFilterProvidersExclusionInfo,
	} = useReportFormInfo(reportFormData.peek().filterProvidersExclusion, "filterProvidersExclusion", object({ filterProvidersExclusion: boolean() }))

	return <AppIconChipToggle
		aria-label="Providers"
		value={!!filterProvidersExclusion}
		options={[
			{ value: false, label: 'Include', icon: 'check' },
			{ value: true, label: 'Exclude', icon: 'ban' },
		]}
		onChange={value => setFilterProvidersExclusionInfo(value)}
	/>
}